export const PAGE_SIZE = 25;
export const SURFACE_IDS = new Set(['items', 'operation']);
export const OWNER_UNCONFIRMED_TOOLTIP = 'proprietário não foi confirmado';
export const LAUDO_STATUS_POLL_INTERVAL_MS = 5000;
export const LAUDO_STATUS_POLL_MAX_ATTEMPTS = 72;
export const MAX_UPLOAD_IMAGE_SIZE = 8 * 1024 * 1024;
export const SENT_STATUSES = [
  'sent',
  'sent_registered_match',
  'partial_sent_failed',
  'midas_price_updated',
  'midas_price_auto_reduced',
  'midas_price_manual_reduced',
  'midas_laudo_registered',
  'midas_laudo_auto_registered',
  'midas_laudo_manual_registered',
  'reactivation_realized',
];
export const PENDING_STATUSES = [
  'detected',
  'dry_run',
  'send_interrupted_no_replay',
  'midas_price_update_processing',
  'midas_laudo_registering',
];
export const SKIPPED_STATUSES = [
  'midas_price_update_skipped',
  'owner_not_authorized',
  'sold',
  'reduction_not_authorized',
];
export const INACTIVE_IN_COMPETITOR_STATUS = 'inactive_in_competitor';
export const HIDDEN_PENDING_STATUSES = [
  INACTIVE_IN_COMPETITOR_STATUS,
  'sent_registered_match',
  'midas_price_update_skipped',
  'skipped_current_price',
  'skipped_duplicate',
  'skipped_invalid_address',
  'skipped_invalid_complement',
  'skipped_out_of_city',
  'skipped_out_of_coverage',
  'skipped_recently_sent',
  'skipped_registered_match',
  'skipped_rent_only',
];
export const HIDDEN_PENDING_STATUS_SET = new Set(HIDDEN_PENDING_STATUSES);
export const HIDDEN_PENDING_STATUSES_PARAM = HIDDEN_PENDING_STATUSES.join(',');
export const FINAL_ACTION_STATUSES = new Set([
  'midas_price_updated',
  'midas_price_auto_reduced',
  'midas_price_manual_reduced',
  'midas_laudo_registered',
  'midas_laudo_auto_registered',
  'midas_laudo_manual_registered',
  'reactivation_realized',
  'owner_not_authorized',
  'sold',
  'reduction_not_authorized',
]);
export const REFUSAL_OPTIONS_BY_KIND = {
  outside_house: [
    {
      value: 'owner_not_authorized',
      label: 'Não autorizado pelo proprietário',
    },
    { value: 'sold', label: 'Vendido' },
  ],
  price_reduction: [
    { value: 'reduction_not_authorized', label: 'Redução não autorizada' },
  ],
};
export const INITIAL_FILTERS = {
  q: '',
  status: '',
  sentState: '',
  sourceKind: '',
  neighbourhood: '',
  city: '',
  updatedSince: '',
  updatedUntil: '',
  sortBy: 'processedAt',
  sortDirection: 'desc',
};
export const HIDDEN_FEED_COLUMNS = new Set([
  'address',
  'streetNumber',
  'complement',
  'status',
  'processedAt',
  'sentAt',
  'sourceUrl',
  'houseUrl',
  'messageText',
]);
export const OWNER_FIELD_KEYS = new Set(['ownerName', 'ownerPhone']);
export const FALLBACK_REGISTRATION_OPTIONS = {
  propertyTypes: [
    { value: '1', label: 'Apartamento' },
    { value: '2', label: 'Cobertura' },
    { value: '3', label: 'Casa de rua' },
    { value: '4', label: 'Kitnet/Conjugado' },
    { value: '5', label: 'Loft' },
    { value: '25', label: 'Flat' },
    { value: '34', label: 'Studio' },
  ],
  mediaDisclosures: [
    { value: '30', label: 'Internet' },
    { value: '63', label: 'Portal OLX' },
    { value: '15', label: 'Portal Viva Real' },
    { value: '13', label: 'Portal Zap' },
    { value: '14', label: 'Portal Imovelweb' },
  ],
  contactForms: [
    { value: '10', label: 'WhatsApp' },
    { value: '7', label: 'Portais' },
  ],
  saleStatuses: [{ value: '1', label: 'AGUARDANDO LIBERAÇÃO VENDA' }],
  optionTypes: [{ value: '1', label: 'Laudo sem documento' }],
  complementTypes: [
    { value: '7', label: 'Apto.' },
    { value: '8', label: 'Casa' },
    { value: '9', label: 'Cob.' },
    { value: '10', label: 'Lj.' },
    { value: '11', label: 'Lote' },
    { value: '12', label: 'Sl.' },
  ],
};
export const REGISTRATION_STEPS = [
  {
    key: 'media',
    step: 'media',
    label: 'Fotos',
    shortLabel: 'Fotos',
    icon: 'i-lucide-images',
  },
  {
    key: 'identity',
    label: 'Contato',
    shortLabel: 'Contato',
    icon: 'i-lucide-user-round',
  },
  {
    key: 'property',
    label: 'Imóvel',
    shortLabel: 'Imóvel',
    icon: 'i-lucide-map-pin-house',
  },
  {
    key: 'pricing',
    label: 'Valores',
    shortLabel: 'Valores',
    icon: 'i-lucide-badge-dollar-sign',
  },
  {
    key: 'publication',
    label: 'Publicação',
    shortLabel: 'Publicar',
    icon: 'i-lucide-file-text',
  },
  {
    key: 'team',
    label: 'Opcionistas',
    shortLabel: 'Time',
    icon: 'i-lucide-users-round',
  },
];

export const INPUT_CLASS =
  'h-10 w-full rounded-lais-sm border border-lais-border bg-white px-3 text-[13px] text-lais-text outline-none transition placeholder:text-lais-text-muted focus:border-lais-primary focus:ring-2 focus:ring-lais-primary-50';
export const SELECT_CLASS = INPUT_CLASS;
export const TEXTAREA_CLASS =
  'min-h-[92px] w-full rounded-lais-sm border border-lais-border bg-white px-3 py-2 text-[13px] text-lais-text outline-none transition placeholder:text-lais-text-muted focus:border-lais-primary focus:ring-2 focus:ring-lais-primary-50';
export const COMPACT_BUTTON_CLASS =
  'inline-flex h-10 items-center justify-center gap-2 rounded-lais border border-lais-border bg-white px-3 text-[13px] font-semibold text-lais-text transition hover:border-lais-primary hover:bg-lais-primary-50/40 disabled:cursor-not-allowed disabled:opacity-50';
export const PRIMARY_COMPACT_BUTTON_CLASS =
  'inline-flex h-10 items-center justify-center gap-2 rounded-lais border border-lais-primary bg-lais-primary px-3 text-[13px] font-semibold text-white transition hover:bg-lais-primary-600 disabled:cursor-not-allowed disabled:opacity-50';
